<template>
  <rich-card class="upload-card">
    <div
      class="upload-card-header"
      slot="header"
      v-if="title"
      v-html="title"
    ></div>
    <div class="upload-card-body" slot="body">
      <rich-upload
        ref="upload"
        :action="action"
        :simultaneous-uploads="simultaneousUploads"
        v-model="fileList"
        :max="max"
        @file-click="fileClickHandler"
        @files-added="filesAddedHandler"
        @file-success="fileSuccessHandler"
        @file-removed="fileRemovedHandler"
      ></rich-upload>
        <!-- :process-file="processFile" -->
        <rich-toast
          ref="toast"
          type="error"
          :txt="toastText"
          :time="4000"></rich-toast>
    </div>
  </rich-card>
</template>

<script>
import { prefixUrl, getCommonParams } from '@/common/utils/request'
import { url2localProtocol } from '@/common/utils/util'
// import compress from '@/common/utils/image'
import { sprintf } from '@didi/gettext'
import { get } from 'lodash-es'
const MAX_FILESIZE = 10
const COMPRESS_FILESIZE = 0.1

export default {
  name: 'uploadimg',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    titleDesc: {
      type: String,
      required: false,
      default: ''
    },
    accept: {
      type: String,
      required: false,
      default: 'image/jpeg, image/jpg, image/png'
    },
    max: {
      type: Number,
      required: false,
      default: 1
    },
    value: {
      type: Array,
      required: false,
      default: () => []
    },
    target: {
      type: String,
      required: false,
      default: prefixUrl('common.uploadPublicPic')
    },
    simultaneousUploads: { // 并发上传个数
      type: Number,
      required: false,
      default: 3
    },
    compressOption: {
      type: Object,
      required: false,
      default: () => ({
        type: 'file',
        compress: {
          width: 1600,
          height: 1600,
          quality: 0.5
        }
      })
    },
    // 限制上传文件大小
    size: {
      type: Number,
      required: false,
      default: Infinity
    }
  },
  data () {
    return {
      action: {
        // max: this.max,
        accept: this.accept,
        multiple: false,
        target: this.target,
        fileName: 'upfile',
        data: {
          ...getCommonParams()
        },
        checkSuccess (res, file) {
          if (res.errno === 0 && res.data) {
            return true
          } else if (res.data && res.data.redirectUrl) {
            self.$createToast({
              type: 'warn',
              time: 1000,
              txt: res.errmsg
            }).show()
            /* eslint-disable */
            setTimeout(() => {
              location.href = res.data.redirectUrl
            }, 1000)
          } else {
            setTimeout(() => {
              self.$createToast({
                type: 'warn',
                time: 1000,
                txt: self.gettext('上传失败，请重新上传')
              }).show()
            }, 0)
            return false
          }
        }
      },
      fileList: [],
      toastText: ''
    }
  },
  methods: {
    fileClickHandler (file) {
      const url = file.customUrl || file.url || ''
      if (url) {
        try {
          this.previewImages = [url2localProtocol(url)]
          setTimeout(() => {
            this.$viewer.show()
          }, 100)
        } catch (err) {
          console.error(err)
          // 自带preview垫底
          this.$createImagePreview({
            imgs: [url]
          }).show()
        }
      }
    },
    filesAddedHandler (files) {
      let self = this
      let maxSize = MAX_FILESIZE * 1024 * 1024
      files = Array.from(files)
      let hasIgnore = false
      for (let file of files) {
        // 唯一标志
        file.fileKey = `${file.name}${new Date().getTime()}`
        file.hasCompressed = file.size < COMPRESS_FILESIZE * 1024 * 1024
        if (file.size > maxSize) {
          file.ignore = true
          hasIgnore = true
        }
      }
      hasIgnore && self.$createToast({
        type: 'warn',
        time: 1000,
        txt: sprintf(self.gettext('上传照片不能超过%dMB，请重新上传'), MAX_FILESIZE)
      }).show()
    },
    fileSuccessHandler (file) {
      let targetIndex = this.fileList.findIndex(i => (i.file || {}).fileKey === file.file.fileKey)
      targetIndex = targetIndex === -1 ? 0 : targetIndex
      this.$set(this.value, targetIndex, {
        name: file.name,
        fileKey: file.file.fileKey,
        customUrl: get(file, 'response.data.url', '') || file.url
      })
      this.$emit('input', this.value)
    },
    fileRemovedHandler (file) {
      console.log('data', file)
      let targetIndex = this.fileList.findIndex(i => (i.file || {}).fileKey === file.file.fileKey)
      if (targetIndex !== -1) {
        this.value.splice(targetIndex, 1)
        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import "~@/common/style/variable.styl"

.upload-card
  padding: 10px 10px 0
  border: 1px solid #ebebeb
  .upload-card-header
    margin-bottom: 20px
    height: 30px
    line-height: 30px
    color: #ccc
  .rich-cell-wrapper
    &::after
      border-bottom 0
    .rich-cell-desc
      flex-grow inherit!important
      color $color-dark-grey
  &-is-required
    font-style normal
    color red
  .rich-upload-btn-def
    background-color: rgba(252,145,83,.2);
    &::after
      border-style: dashed
      border-color: #ff7a45
    >i
      &::before,
      &::after
        background-color: #ff7a45
</style>
